import { Component } from "react";
import language from "../../../../language";
import { connect } from "react-redux";
import { Table } from "../../../Table";
import { Modal } from "../../../Modal";
import { getStorage } from "../../../../utils/storage";
import toastMessage from "../../../../utils/toastMessage";
import {
// eslint-disable-next-line no-unused-vars
  fetchRequestedProducts,
} from "../../../../utils/queries/request-product";
import AddForward from "./Add";
import icons from "../../../../constants/icons";
import { ROLE_LABORATORY } from "../../../../constants/ROLES";
import { defineRole } from "../../../../utils/handleAccessRoles";

class ForwardedRequestProducts extends Component {
  state = {
    error: {},
    user: {},
    data: [],
    selectedData: {},
    page: 1,
    limit: 50,
    requestedProducts: [],
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    if (this.props.requestId) {
      this.getProducts(true);
      this.getRequestedProducts(true);
    }
  };

  getRequestedProducts = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const { defaultLanguage, requestId } = this.props;

      const { data } = await fetchRequestedProducts(defaultLanguage, {
        page: 1,
        limit: 50,
        request: requestId,
      });

      this.setState({
        isLoading: false,
        requestedProducts: data,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
      toastMessage("error", error);
    }
  };

  getProducts = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const { defaultLanguage, requestId } = this.props;

      const { data, count, totalRecords } = await fetchRequestedProducts(defaultLanguage, {
        page: 1,
        limit: 50,
        forwadedRequest: requestId,
      });

      console.log({
        data,
        requestId,
      });

      this.setState({
        isLoading: false,
        data: data,
        totalPageCount: count,
        totalRecords,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
      toastMessage("error", error);
    }
  };

  renderProductHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].request_number,
        key: "request.requestNo",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/request/bulk/${item.request.requestNo}`),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "productType.name",
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
      },
      {
        title: language[this.props.defaultLanguage].number_of_packages,
        key: "numberOfPackages",
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
      },
    ];
    return headers;
  }

  handleOpenModal = async (modal) => {
    this.setState({
      [modal]: true,
    });
  };

  handleCloseModal = async (modal) => {
    this.setState({
      [modal]: false,
    });
  };

  render() {
    const canAddProducts = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_LABORATORY,
      operation: "create",
    });
    return (
      <div>
        <>
          <Table
            isLoading={this.state.isLoading}
            data={this.state.data}
            headers={this.renderProductHeaders()}
            page={this.state.page}
            limit={this.state.limit}
            totalPageCount={this.state.totalPageCount}
            totalRecords={this.state.totalRecords}
            showAdd={canAddProducts}
            addButtonText={language[this.props.defaultLanguage].add}
            handleAddPressed={() => {
              if (!this.props.sampleBloodGroup) {
                toastMessage(
                  "error",
                  language[this.props.defaultLanguage].sample_blood_group_required
                );
                return;
              }
              if (!this.props.requestedProductsCount) {
                toastMessage(
                  "error",
                  language[this.props.defaultLanguage].product_required ||
                    "At least one requested product is required before forwarding"
                );
                return;
              }
              this.handleOpenModal("showAdd");
            }}
            filters={[
              {
                type: "button",
                title: language[this.props.defaultLanguage].refresh,
                button_type: "button",
                icon: icons.refresh,
                onPress: (item) => this.getProducts(),
              },
            ]}
          />
        </>
        <Modal
          show={this.state.showAdd}
          handleClose={() => this.handleCloseModal("showAdd")}
          title={language[this.props.defaultLanguage].forward_request || "Forward Request"}
          size="lg"
        >
          <AddForward
            from={this.props.from || this.state.user.hospital}
            to={this.props.to}
            allowedBloodBankName={this.props.allowedBloodBankName}
            multipleAllowedBloodBanks={this.props.multipleAllowedBloodBanks || []}
            requestId={this.props.requestId}
            requestNo={this.props.requestNo}
            requestingDoctorName={this.props.requestingDoctorName}
            requestingDoctorContacts={this.props.requestingDoctorContacts}
            requestingDoctorEmail={this.props.requestingDoctorEmail}
            requestedByAccount={this.props.requestedByAccount}
            handleCloseModal={() => this.handleCloseModal("showAdd")}
            getData={() => this.getProducts(true)}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ForwardedRequestProducts);
